var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg500Error(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 119.625,
    cy: 114.375,
    r: 101.625,
    fill: "#D9EBC7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M215.62 157.436L135.389 18.4727C128.549 6.62624 111.451 6.62622 104.611 18.4727L24.3803 157.436C17.5407 169.283 26.0901 184.091 39.7692 184.091H200.231C213.91 184.091 222.459 169.283 215.62 157.436Z",
    fill: "#F9B810",
    stroke: "#000072",
    strokeWidth: 8.18182
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.064 127.032C114.425 133.956 124.329 133.956 125.69 127.032L135.639 76.3772C136.42 72.4025 133.377 68.7041 129.327 68.7041L109.427 68.7041C105.377 68.7041 102.334 72.4025 103.115 76.3772L113.064 127.032ZM123.956 155.056C126.783 152.23 126.783 147.647 123.956 144.821C121.13 141.995 116.547 141.995 113.721 144.821L113.643 144.899C110.816 147.726 110.816 152.308 113.643 155.134C116.469 157.961 121.052 157.961 123.878 155.134L123.956 155.056Z",
    fill: "#000072"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg500Error);
export default __webpack_public_path__ + "static/media/500_error.e89c345e9504c55c5b061f150e592072.svg";
export { ForwardRef as ReactComponent };